import React, { useState } from "react";
import { ChromePicker } from "react-color"; // Color picker
import { useDropzone } from "react-dropzone"; // File upload
import axios from "axios";
import { baseURL } from "../../axios/common";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import { useParams } from "react-router-dom";

const EditSport = () => {
  const { sport_id } = useParams();
  const [name, setName] = useState(""); // For sport name
  const [color, setColor] = useState(""); // No default color
  const [icon, setIcon] = useState(null); // For uploaded icon
  const [iconPath, setIconPath] = useState(""); // Path returned from upload API
  const [uploading, setUploading] = useState(false); // Upload loading state

  // Handle name change
  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  // Handle color change
  const handleColorChange = (color) => {
    setColor(color.hex);
  };

  // Handle file drop
  const onDrop = (acceptedFiles) => {
    setIcon(acceptedFiles[0]); // Set the uploaded file
    uploadFile(acceptedFiles[0]); // Upload file to get path
  };

  // Use react-dropzone to handle file input
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  // Upload file function
  const uploadFile = async (file) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(baseURL + "global/upload?folder=sport-icons", formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.status) {
        setIconPath(response.data.path.replace(/^\/+/, "")); 
      } else {
        alert("File upload failed");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setUploading(false);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      id: sport_id,
      name,
      color_code: color,
      icon_path: iconPath, 
    };

    try {
      const response = await axios.post(baseURL + "sports/edit", payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.status) {
        alert(response.data.message);
        setName("");
        setColor(""); 
        setIcon(null);
        setIconPath("");
      } else {
        alert("Failed to add sport");
      }
    } catch (error) {
      console.error("Error adding sport:", error);
    }
  };

  return (
    <>
        <Header />
        <SideBar />
        <main>
        <div className="content-wrapper pt-5 create_user">
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <h2>Edit Sport</h2>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-9">
                        <form onSubmit={handleSubmit}>
                            {/* Name */}
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                            <label style={{ fontSize: "16px", marginBottom: "8px" }}>Name</label>
                            <input
                                type="text"
                                value={name}
                                onChange={handleNameChange}
                                placeholder="Enter sport name"
                                className="form-control"
                                style={{
                                padding: "10px", border: "1px solid #ccc", borderRadius: "5px", fontSize: "14px", outline: "none", width: "100%",
                                }}
                            />
                            </div>

                            {/* Color Picker */}
                            <div className="form-group" style={{ marginBottom: "15px", width: "100%" }}>
                            <label style={{ fontSize: "16px", marginBottom: "8px", display: "block" }}>Color</label>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <ChromePicker color={color || "#ffffff"} onChange={handleColorChange} />
                            </div>
                            </div>

                            {/* Upload*/}
                            <div className="form-group" {...getRootProps()} style={{ marginBottom: "15px", border: "1px dashed #ccc", padding: "20px", borderRadius: "5px", textAlign: "center" }}>
                            <label style={{ fontSize: "16px", marginBottom: "8px" }}>Upload Icon</label>
                            <input {...getInputProps()} />
                            {uploading ? (
                                <p style={{ fontSize: "16px", color: "#999" }}>Uploading...</p>
                            ) : icon ? (
                                <div style={{ textAlign: "center" }}>
                                <p>{icon.name}</p>
                                <img src={URL.createObjectURL(icon)} alt="icon-preview" style={{ width: "50px", margin: "0 auto" }} />
                                </div>
                            ) : (
                                <p style={{ fontSize: "24px", color: "#999" }}><i className="fa fa-upload fa-3x"></i></p>
                            )}
                            </div>

                            {/* Submit Button */}
                            <button type="submit" className="btn btn-primary" style={{ width: "100%", padding: "10px 20px", fontSize: "16px", backgroundColor: "#FF5733", border: "none", borderRadius: "5px", cursor: "pointer" }}>Submit</button>
                            </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default EditSport;
